export default {
  cart: [],
};
